import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { EntityService } from 'src/app/services/entity.service';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent implements OnInit {
  registerForm!: FormGroup;
  submited: boolean = false;
  entityLogo!: string;
  pageTitle: string = 't-register';
  isDisabled: boolean = false;

  constructor(
    private eventService: EventService,
    private entityService: EntityService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.authService?.currentUserValue) {
      this.router.navigate(['/']);
    }
    this.eventService.broadcast('header-page-title', this.pageTitle);
    const entityData: any = localStorage.getItem('entityData');
    this.entityLogo = JSON.parse(entityData).logo;
    //this.entityService.getEntityLogo().subscribe(logo => this.entityLogo = logo);
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });
  }

  get form() {
    return this.registerForm.controls;
  }

  submitRegister() {
    this.submited = true;
    if (this.validationForm()) {
      this.isDisabled = true;
      const data = {
        name: this.form['name'].value,
        email: this.form['email'].value,
        password: this.form['password'].value,
      };
      this.authService.register(data).subscribe({
        next: (result: any) => {
          this.isDisabled = false;
          localStorage.setItem('userEmail', this.form['email'].value);
          this.router.navigate(['/account/validate-code']);
        },
        error: (err: any) => {
          console.log(err);
          this.isDisabled = false;
          this.registerForm.controls['email'].setErrors({
            userExists: true,
          });
        },
      });
    }
  }

  validationForm() {
    if (this.form['password'].value !== this.form['confirmPassword'].value) {
      this.registerForm.controls['confirmPassword'].setErrors({
        diferentPass: true,
      });
      return false;
    }
    return this.registerForm.valid &&
      this.form['password'].value === this.form['confirmPassword'].value
      ? true
      : false;
  }
}
